import React, { useState, useEffect } from 'react';
import { CSSTransition } from 'react-transition-group';

const duration = 70;
const durationPagination = 180;

const defaultStyle = {
  transition: `opacity ${duration}ms ease-in-out`,
  opacity: 0
};

const transitionStyles = {
  entering: { opacity: 0.20 },
  entered: { opacity: 1 }
};

const AnimatePagination = ({ in: inProp, isMounted, children = null }) => {
  return (
    <CSSTransition in={inProp} timeout={durationPagination}>
      {(state) => (
        <div style={{
          ...defaultStyle,
          ...transitionStyles[state]
        }}>
          {children}
        </div>)}
    </CSSTransition>
  );
};

const AnimateEnter = ({ children = null, durationProp, paginationAnimate = false }) => {
  const [ isMounted, setIsMounted ] = useState(false);
  useEffect(() => {
    setIsMounted(true);
  }, []);
  return (
    <CSSTransition in={isMounted} timeout={durationProp || duration}>
      {(state) => (
        <div style={{
          ...defaultStyle,
          ...transitionStyles[state]
        }}>
          {paginationAnimate
            ? <AnimatePagination in={paginationAnimate.isMounted}>
                {children}
              </AnimatePagination>
            : children}
        </div>)}
    </CSSTransition>
  );
};

export default AnimateEnter;
